import { render, staticRenderFns } from "./ShopOverview.vue?vue&type=template&id=030fd8de&scoped=true"
import script from "./ShopOverview.vue?vue&type=script&lang=js"
export * from "./ShopOverview.vue?vue&type=script&lang=js"
import style0 from "./ShopOverview.vue?vue&type=style&index=0&id=030fd8de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030fd8de",
  null
  
)

export default component.exports